import * as Yup from 'yup';

export const PersonSelectSchema = Yup.object().shape({
  personId: Yup.string().required('Vous devez sélectionner une personne'),
});
